import { memo } from 'react';
import { Circle, Group } from 'react-konva';
import Konva from 'konva';
import { Tree } from 'store/slices/TreeSlice';

type Props = Konva.GroupConfig & {
	tree: Tree;
	onPointerDown?: (e: Konva.KonvaEventObject<PointerEvent>) => void;
	onDragEnd?: (e: Konva.KonvaEventObject<DragEvent>) => void;
	isSelected?: boolean;
	isHovered?: boolean;
};

const TRUNK_FILL = 'rgba(139, 69, 19, 0.75)';
const CROWN_FILL = 'rgba(34, 139, 34, 0.35)';
const CROWN_FILL_SELECTED = 'rgba(20, 83, 20, 0.75)';
const CROWN_STROKE = '#228B22';
const CROWN_STROKE_SELECTED = '#145314';

export default function TreeNode(props: Props) {

	const { tree, isSelected, isHovered, onPointerDown, onDragEnd, ...groupConfig } = props;

	const showSelectedStyle = !!isSelected || !!isHovered;
	const crownFill = showSelectedStyle ? CROWN_FILL_SELECTED : CROWN_FILL;
	const crownStroke = showSelectedStyle ? CROWN_STROKE_SELECTED : CROWN_STROKE;
	const crownStrokeWidth = showSelectedStyle ? 2 : 1;

	return (
		<Group
			x={tree.x}
			y={tree.y}
			id={`Tree-${tree.id}`}
			onPointerDown={onPointerDown}
			onDragEnd={onDragEnd}
			{...groupConfig}
		>
			{/* crown */}
			<Circle
				radius={tree.crownRadius}
				fill={crownFill}
				stroke={crownStroke}
				strokeWidth={crownStrokeWidth}
			/>

			{/* trunk */}
			<Circle
				radius={tree.trunkRadius}
				fill={TRUNK_FILL}
			/>
		</Group>
	);
}